import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	data: null,
	loading: false,
	error: null,
};

const workflowHistoriesSlice = createSlice({
	name: "workflowHistories",
	initialState,
	reducers: {
		fetchWorkflowHistoriesRequest: (state) => {
			state.loading = true;
			state.error = null;
		},
		fetchWorkflowHistoriesSuccess: (state, action) => {
			state.loading = false;
			state.data = action.payload;
		},
		fetchWorkflowHistoriesFailure: (state, action) => {
			state.loading = false;
			state.error = action.payload;
		},
	},
});

export const { fetchWorkflowHistoriesRequest, fetchWorkflowHistoriesSuccess, fetchWorkflowHistoriesFailure } = workflowHistoriesSlice.actions;

export default workflowHistoriesSlice.reducer;
